export enum EStatusAberturaCaixa {
    Aberta = 1,
    Fechada = 2,
    Reaberta = 3,
}
